import idx from 'idx'
import { subDays } from 'date-fns'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { animateScroll } from 'react-scroll'
import { downloadDataAsCsv } from 'utils/files'
import withMixpanel, { GROUP_DATA_FILTER, SCREEN_VIEW_TRAP_DATA_GROUPS, EXPORT_DATA_GROUP_REPORT } from 'utils/mixpanel'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

// import { GROUP_DATA } from 'constants/form'
import { DATE_DROPDOWN_DEFAULT } from 'constants/tables'
import { isEqual, getPaginationObject } from 'utils/misc'

import * as mapModule from 'modules/map'
import * as groupModule from 'modules/group'
import * as userActions from 'actions/userActions'
import * as popoverModule from 'modules/popover'
import {GROUP_DATA} from "constants/form";

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        groups: idx(state, _ => _.groups.items),
        heatmapOpen: idx(state, _ => _.map.heatmap),
        mapDataLoaded: !!idx(state, _ => _.map.data),
        tableLoading: idx(state, _ => _.groups.loading),
        organisation: idx(state, _ => _.organisation.selected)
      }
    },
    (dispatch) => {
      const actions = {
        ...mapModule,
        ...userActions,
        ...groupModule,
        ...popoverModule
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      selectedRange: DATE_DROPDOWN_DEFAULT,
      filters: {
        dateLimit: subDays(new Date(), DATE_DROPDOWN_DEFAULT.value),
        search: [{ key: 'groupName', value: null }],
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
      }
    }),
    {
      handleRangeChange: state => selectedRange => ({
        ...state,
        selectedRange,
        filters: {
          ...state.filters,
          dateLimit: subDays(new Date(), selectedRange.value),
          loaded: false,
        }
      }),
      onPageChange: state => (offset) => {
        return getPaginationObject(state, { offset }, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    onSearchChange: ({ setFilters }) => (value) => {
      setFilters({ search: [{ key: 'groupName', value }] })
    },
    onTableRowClick: ({ actions }) => (row) => {
      actions.showGroupDetail(row)
    },
    onTableSortClick: ({ setFilters }) => (orderBy) => {
      setFilters({ orderBy: [orderBy] })
    },
    onTableSelectableClick: ({ actions }) => (selectable) => {
      animateScroll.scrollTo(55, { duration: 500 })
      setTimeout(() => {
        actions.focusGroup(selectable.groupUuid)
      }, 500)
    },
    onExportClick: ({ 
      track, actions, organisation
    }) => () => {
      actions.showPopover(popoverModule.EXPORT_DATA, {type: GROUP_DATA})
    },
    onRangeChange: ({ track, handleRangeChange }) => (selectedRange) => {
      track(GROUP_DATA_FILTER(selectedRange))
      handleRangeChange(selectedRange)
    },
  }),
  lifecycle({
    componentDidMount() {
      const { 
        track, actions, organisation, filters, setPagination
      } = this.props

      track(SCREEN_VIEW_TRAP_DATA_GROUPS)
      actions.getReportGroups(organisation, filters, setPagination)
    },
    componentDidUpdate(prevProps) {
      const { 
        actions, organisation, filters, setPagination
      } = this.props

      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getReportGroups(organisation, filters, setPagination)
      }
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/groups/GroupDataOverview/GroupDataOverview.enhancer.js